import { distinctUntilChanged, debounceTime, tap, filter, switchMap, finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { ActivatedRoute } from '@angular/router';
import { isNumber } from 'highcharts';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import {SearchAlicuotaIvaRequest, AlicuotaIva, TenantFeatureFlags, LocalStorageKeys, DialogAgregarComparativa,
  SearchMonedaRequest, Moneda, MaterialDto, PedidoItemDto, MenuFuncionCodes, FormaDePago, TipoCompra, SearchFormaDePagoRequest, Proveedor, SearchProveedorRequest, SearchMaterialRequest, SavePedidoPresupuesto, PedidoPresupuestoFormaPago, PedidoPresupuestoDetalle
 } from '../../../../../src/app/shared/model';
import { MaterialesService, AlicuotaIvaService, FormaDePagoService, MenuFuncionService, MonedaService, PedidoService, ProveedorService, TenantService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-dialog-agregar-comparativa',
  templateUrl: './dialogAgregarComparativa.component.html',
  styleUrls: ['./dialogAgregarComparativa.component.scss']
})

export class DialogAgregarComparativaComponent implements OnInit {

  @ViewChild('detalleGrid')
  public detalleGrid: GridComponent;

  public title: string;
  public message: string;
  public buttonAcceptText: string;
  public buttonCancelText: string;

  isSearching: boolean = false;
  isMaterialSearching: boolean = false;
  isDetalleSearching: boolean = false;
  isProveedorSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;
  isTipoCompraSearching: boolean = false;
  isFormaPagoSearching: boolean = false;
  isPedidoItemsSearching: boolean = false;
  isPresupuestoDetalleSearching: boolean = false;
  isDeleting: boolean = false;
  isSaving: boolean = false;
  isSavingSeleccion: boolean = false;
  isValidating: boolean = false;
  isAlicuotaIvaSearching: boolean = false;

  canSelect: boolean = false;
  canEdit: boolean = false;

  formGroup: FormGroup;

  presupuestosList: any[] = [];
  proveedorList: any[] = [];
  pedidoItemList: PedidoItemDto[];

  formaPagoList: FormaDePago[] = [];
  tipoCompraList: TipoCompra[] = [];
  monedaList: Moneda[] = [];
  filteredMaterialList: MaterialDto[] = [];
  alicuotaIvaList: AlicuotaIva[];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;
  msgError: string = "";

  presupuestoUrl: string = '';
  presupuestoAdjuntoBase64: string | ArrayBuffer | null;
  presupuestoAdjuntoExtension: string = "";
  comprobanteFile: any;
  selectedFile: any;

  tenantFeatureFlags: TenantFeatureFlags;

  constructor(
    private dialogRef: MatDialogRef<DialogAgregarComparativa>,
    @Inject(MAT_DIALOG_DATA) public data: DialogAgregarComparativa,
    private menuService: MenuFuncionService,
    private pedidoService: PedidoService,
    private route: ActivatedRoute,
    private monedaService: MonedaService,
    private proveedorService: ProveedorService,
    private formaPagoService: FormaDePagoService,
    private materialService: MaterialesService,
    private sharedFunctions: SharedFunctions,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private alicuotaIvaService: AlicuotaIvaService,
    private tenantService: TenantService,
  ) { }

  ngOnInit() {
    this.menuService.checkMenu(MenuFuncionCodes.PEDIDO_PRESUPUESTO_LIST).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;
          }
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });

    this.buttonAcceptText = 'Guardar';
    this.buttonCancelText = (this.data.CanEditPresupuesto ? 'Cancelar' : 'Cerrar');
  }

  loadView() {
    this.canEdit = this.data?.CanEditPresupuesto ?? false;
    this.canSelect = this.data?.CanSelectPresupuesto ?? false;
    this.pedidoItemList = this.data?.PedidoItems;

    if (this.data?.PedidoItems != null && this.data?.PedidoItems.length > 0) {
      for (var i=0; i<this.data?.PedidoItems.length; i++)
        this.presupuestosList[this.data?.PedidoItems[i].Id] = {
          PedidoItemId: this.data?.PedidoItems[i].Id,
          Proveedores: []
        };
    }

    this.buildForm();

    this.getTipoCompra();
    this.getFormaDePago();
    this.getMoneda();
    this.getAlicuotaIva();

    // console.log(this.presupuestosList);
  }

  getAlicuotaIva() {
    this.isAlicuotaIvaSearching = true;
    var r = new SearchAlicuotaIvaRequest(null,null,null,null,null,null,null,null,true);

    this.alicuotaIvaService.search(r).subscribe((data)=>{
      this.isAlicuotaIvaSearching = false;
      this.alicuotaIvaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isAlicuotaIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  displayMaterial(material: MaterialDto): string {
    return material && material?.Nombre ? material.Nombre : '';
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Codigo': [null, Validators.maxLength(100)],
      'Proveedor': [null, [Validators.required, Validators.maxLength(150)]],
      'FormaPagoId': [null, Validators.required],
      'MonedaId': [null, Validators.required],
      'Monto': [null, Validators.required],
      'TipoCompra': [null, Validators.required],
      'FechaVigencia': [new Date()],
      'Observacion': [null],
      'AlicuotaIva': [null]
    });

    if (this.tenantFeatureFlags?.HabilitarControlCaja) {
      const alicuotaIvaControl = this.formGroup.get('AlicuotaIva');

      alicuotaIvaControl?.setValidators([Validators.required]);
      alicuotaIvaControl?.updateValueAndValidity();
    }
  }

  getTipoCompra() {
    this.isTipoCompraSearching = true;
    this.pedidoService.getAllTipoCompra().subscribe(data=> {
      this.isTipoCompraSearching = false;
      this.tipoCompraList = data?.Result;
    },
    (err: HttpErrorResponse)=> {
      this.isTipoCompraSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMoneda() {
    this.isMonedaSearching = true;
    this.monedaService.search(new SearchMonedaRequest(null,null,true,"Codigo",null,null,null,true)).subscribe(data=> {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;
    },
    (err: HttpErrorResponse)=> {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getFormaDePago() {
    this.isFormaPagoSearching = true;
    this.formaPagoService.search(new SearchFormaDePagoRequest(null,null,true,"Nombre",null,null,true)).subscribe(data=> {
      this.isFormaPagoSearching = false;
      this.formaPagoList = data?.result;
    },
    (err: HttpErrorResponse)=> {
      this.isFormaPagoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getProveedoresAutocomplete(itemId: number, index: number) {
    var f = this.presupuestosList[itemId].Proveedores[index].ProveedorFormGroup.get('Proveedor') as FormGroup;
    f?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.presupuestosList[itemId].Proveedores[index].FilteredProveedorList = [];
          this.presupuestosList[itemId].Proveedores[index].IsProveedorAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.presupuestosList[itemId].Proveedores[index].IsProveedorAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.presupuestosList[itemId].Proveedores[index].FilteredProveedorList = data.result;
        else
          this.presupuestosList[itemId].Proveedores[index].FilteredProveedorList = [];
        // (this.filteredProveedorList, 'lista proveedor')
      });
  }

  getMaterialesAutocomplete(itemId: number, index: number) {
    var f = this.presupuestosList[itemId].Proveedores[index].MaterialFormGroup.get('Material') as FormGroup;
    f?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.presupuestosList[itemId].Proveedores[index].FilteredMaterialList = [];
          this.presupuestosList[itemId].Proveedores[index].IsMaterialAutoSearching = true;
        }),
        switchMap(value => this.materialService.search(new SearchMaterialRequest(null, null, null, null, value, null,this.data.PedidoTipoMaterialId, true))
          .pipe(
            finalize(() => {
              this.presupuestosList[itemId].Proveedores[index].IsMaterialAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.presupuestosList[itemId].Proveedores[index].FilteredMaterialList = data.result;
        else
          this.presupuestosList[itemId].Proveedores[index].FilteredMaterialList = [];
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  onGuardarPresupuesto() {
    if (this.presupuestosList == null || this.presupuestosList.length == 0) {
      this.sharedFunctions.showMessage("No hay materiales cargados para la comparativa", "Error");
      return false;
    }

    if (this.proveedorList == null || this.proveedorList.length == 0) {
      this.sharedFunctions.showMessage("No hay presupuestos de proveedores cargados para la comparativa", "Error");
      return false;
    }

    var requestList: SavePedidoPresupuesto[] = [];
    var index = this.presupuestoAdjuntoBase64?.toString()?.indexOf(",");

    for (var i=0; i<this.proveedorList.length; i++) {

      // console.log("for",this.proveedorList[i]);
      var proveedorDetalles: PedidoPresupuestoDetalle[] = [];
      this.presupuestosList.forEach(item => {
        // console.log("forEach",item);
        if (item != null && item.Proveedores != null && item.Proveedores.some(f => f.Proveedor.Id == this.proveedorList[i].Id)) {
          var proveedList = item.Proveedores.filter(f => f.Proveedor.Id == this.proveedorList[i].Id);
          for (var j=0; j<proveedList.length; j++) {
            proveedorDetalles.push(new PedidoPresupuestoDetalle(0, 0, item.PedidoItemId, null, proveedList[j].MonedaId, null, proveedList[j].MontoUnitario,
              proveedList[j].Cantidad, proveedList[j].Detalle, (proveedList[j].Cantidad * proveedList[j].MontoUnitario), proveedList[j].EsVariante,
              proveedList[j].Material?.Id, null, false, null, false));
          }
        }
      });

      // console.log(proveedorDetalles);
      if (proveedorDetalles != null && proveedorDetalles.length > 0) {
        requestList.push(new SavePedidoPresupuesto(
          0,
          this.data.PedidoId,
          proveedorDetalles[0].MonedaId,
          this.proveedorList[i].TipoCompra,
          this.proveedorList[i].Id,
          (this.proveedorList[i].Subtotal * (1 + (this.proveedorList[i].AlicuotaIva != null ? this.proveedorList[i].AlicuotaIva.Porcentaje : 0) / 100)),
          null,
          proveedorDetalles,
          this.proveedorList[i].FormaPagoId?.map(s => new PedidoPresupuestoFormaPago(0, 0, s, "")),
          this.proveedorList[i],
          this.proveedorList[i].AlicuotaIva?.Id,
          (this.proveedorList[i].IncluyeFlete ?? false),
          true,
          (index != null && index >= 0 ? this.presupuestoAdjuntoBase64?.toString()?.substring(index + 1) : null),
          this.presupuestoAdjuntoExtension
        ));
      }
    }

    // console.log(requestList);
    this.isSaving = true;
    this.pedidoService.savePresupuestoComparativa(requestList).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.length > 0) {
        //this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.dialogRef.close(data.Result);
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  selectFile(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.comprobanteFile = event.target.files;
    }
    let files = [].slice.call(event.target.files);
    this.selectedFile = files.map(f => f.name).join(', ');
    this.convertFileToBase64(event);
  }

  convertFileToBase64(event) {
    this.presupuestoAdjuntoBase64 = null;
    const file = event.target.files[0];
    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.presupuestoAdjuntoBase64 = reader.result;
      };
      reader.onloadend = () => {
        this.presupuestoAdjuntoBase64 = reader.result;
        this.presupuestoAdjuntoExtension = (file?.name?.split('.')?.pop() ?? "");
      };
    }
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  deleteFile() {
    this.presupuestoUrl = '';
    this.presupuestoAdjuntoBase64 = null;
    this.presupuestoAdjuntoExtension = '';
    this.comprobanteFile = null;
  }

  getErrorProveedor() {
    return this.formGroup.get('Proveedor')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorFormaPago() {
    return this.formGroup.get('FormaPagoId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorAlicuotaIva() {
    return this.formGroup.get('AlicuotaIva')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorTipoCompra() {
    return this.formGroup.get('TipoCompra')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorMoneda() {
    return this.formGroup.get('MonedaId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorMonto() {
    return this.formGroup.get('Monto')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  onAgregarProveedor(item: PedidoItemDto) {
    if (item != null && item.Id > 0) {
      if (this.presupuestosList == null)
        this.presupuestosList = [];

      var i = this.presupuestosList[item.Id].Proveedores.push({
        ProveedorFormGroup: null,
        IsProveedorAutoSearching: false,
        FilteredProveedorList: [],
        Proveedor: null,
        MaterialFormGroup: null,
        IsMaterialAutoSearching: false,
        FilteredMaterialList: [],
        Material: null,
        EsVariante: false,
        Detalle: null,
        Cantidad: item.Cantidad,
        MonedaId: 0,
        MontoUnitario: 0
      });
      i--;

      this.presupuestosList[item.Id].Proveedores[i].ProveedorFormGroup = this.formBuilder.group({
        'Proveedor': [null]
      });
      this.getProveedoresAutocomplete(item.Id, i);
      this.presupuestosList[item.Id].Proveedores[i].ProveedorFormGroup.patchValue({
        Proveedor: new Proveedor(0, null, null, null, null, null, null, null, null, null, null, null, true, null, null, null, null, [])
      });

      this.presupuestosList[item.Id].Proveedores[i].MaterialFormGroup = this.formBuilder.group({
        'Material': [null]
      });
      this.getMaterialesAutocomplete(item.Id, i);
      this.presupuestosList[item.Id].Proveedores[i].MaterialFormGroup.patchValue({
        Material: new MaterialDto(0, null, null, null, null, null, null, true)
      });

      // console.log(this.presupuestosList[item.Id].Proveedores, this.presupuestosList[item.Id].Proveedores[i]);
    }
  }

  deleteProveedor(pedidoItemId: number, proveedorId: number) {
    if (this.presupuestosList != null && this.presupuestosList[pedidoItemId] != null && this.presupuestosList[pedidoItemId].Proveedores != null) {
      var index = this.presupuestosList[pedidoItemId].Proveedores.findIndex(f => f.Id == proveedorId);
      if (index >= 0) {
        this.presupuestosList[pedidoItemId].Proveedores.splice(index, 1);
        this.updateProveedoresList();
      }
    }
  }

  onMaterialSelect(itemProveedor: any) {
    if (itemProveedor != null)
      itemProveedor.Material = itemProveedor.MaterialFormGroup.get("Material")?.value;
  }

  onProveedorSelect(itemProveedor: any) {
    // console.log(itemProveedor);
    if (itemProveedor != null)
      itemProveedor.Proveedor = itemProveedor.ProveedorFormGroup.get("Proveedor")?.value;

     this.updateProveedoresList();
  }

  updateProveedoresList() {
    // console.log("updateProveedoresList");
    if (this.proveedorList == null)
      this.proveedorList = [];

    var allProveedores = [];

    if (this.presupuestosList != null && this.presupuestosList.length > 0) {
      this.presupuestosList.forEach(item => {
        // console.log(item);
        if (item != null) {
          for (var j=0; j<item.Proveedores.length; j++) {
            if (item.Proveedores[j].Proveedor != null) {
              var subTotal = ((item.Proveedores[j].Cantidad ?? 0) * (item.Proveedores[j].MontoUnitario ?? 0));
              var index = allProveedores.findIndex(f => f.Id == item.Proveedores[j].Proveedor?.Id);
              if (index < 0) {
                index = allProveedores.push(item.Proveedores[j].Proveedor);
                index--;
                allProveedores[index].Subtotal = 0;
              }

              allProveedores[index].Subtotal += subTotal;
            }
          }
        }
      });
    }

    if (allProveedores != null && allProveedores.length > 0) {
      for (var j=0; j<allProveedores.length; j++) {
        if (!this.proveedorList.some(f => f.Id == allProveedores[j]?.Id))
          this.proveedorList.push(allProveedores[j]);
      }
    }

    if (this.proveedorList != null && this.proveedorList.length > 0) {
      var indexForDeleting = [];
      for (var j=0; j<this.proveedorList.length; j++) {
        if (!allProveedores.some(f => f.Id == this.proveedorList[j]?.Id))
          indexForDeleting.push(j);
      }

      // console.log(indexForDeleting);
      indexForDeleting = indexForDeleting.sort((a, b) => b - a);
      for (var ii=0; ii<indexForDeleting.length; ii++)
        this.proveedorList.splice(indexForDeleting[ii], 1);
    }

    // console.log(this.proveedorList);
  }
}
